import { create } from "zustand";

interface state {
  copyProduct: string | null;
}

interface action {
  setCopyProduct: (data: state["copyProduct"]) => void;
}

const useStore = create<state & action>((set) => ({
  copyProduct: null,
  // Actions
  setCopyProduct: (data) =>
    set(() => ({
      copyProduct: data,
    })),
}));

export default useStore;
